<template>
  <v-list-item three-line>
    <v-list-item-content>
      <v-list-item-title class="text-truncate">
        <div style="display: flex">
          <div>
            <a v-if="hasOpenDetailListener()" @click.stop="emitOpenDetail">
              {{ item.firstName }} {{ item.lastName }}
            </a>
            <span v-else> {{ item.firstName }} {{ item.lastName }} </span>
          </div>
          <v-spacer />
        </div>
      </v-list-item-title>
      <v-list-item-subtitle v-if="!small" class="text-truncate text-xs">
        <span v-if="item.contact && item.contact.phone">
          <v-icon x-small>mdi-phone</v-icon>
          {{ item.contact.phone }}
        </span>
        <span v-if="item.contact && item.contact.email">
          <v-icon x-small>mdi-email</v-icon>
          {{ item.contact.email }}
        </span>
        <span v-else-if="item.userName">
          <v-icon x-small>mdi-email</v-icon>
          {{ item.userName }}
        </span>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { MrfiktivPartnerCustomerUserViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

@Component({
  components: {},
  filters: {}
})
class RefsCustomerAccount extends mixins(Vue) implements IRefDetail<MrfiktivPartnerCustomerUserViewModelGen> {
  @Prop()
  item!: MrfiktivPartnerCustomerUserViewModelGen;

  @Prop()
  small!: boolean;

  @Prop({ default: false })
  hideCustomerAccount!: boolean;

  @Prop({ default: false })
  hideDate!: boolean;

  @Prop()
  confirmable!: boolean;

  get date() {
    return simpleDoubleDigitDate(this.item.timestamp.created);
  }

  hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  async goToDetail() {
    throw Error("Not implemented yet");
  }
}

export default RefsCustomerAccount;
</script>
<style lang="css" scoped>
.hoverCursorMouse :hover {
  cursor: pointer;
}
</style>
